"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CroupierBlackjackRule = void 0;
const logic_types_1 = require("../logic-types");
const game_rule_1 = require("./game-rule");
const auto_croupier_reveal_command_1 = require("../commands/auto-commands/auto-croupier-reveal-command");
class CroupierBlackjackRule extends game_rule_1.AbstractGameRule {
    constructor(playerId) {
        super();
        this.playerId = playerId;
    }
    applyRule(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const player = context.playerManager.playerFromId(this.playerId);
            const peekIndex = context.playerManager.croupier.croupierBlackjackPeekIndex;
            if (peekIndex) {
                const croupierBlackjack = yield context.dealProcessor.askDealerForCardPeek(peekIndex, commandHash, existingDeal);
                context.eventQueue.enqueue({
                    type: "onCroupierPeek",
                    instant,
                    payload: {
                        croupier: context.playerManager.croupier.clone(),
                    },
                });
                if (croupierBlackjack) {
                    yield this.revealCroupierCard(commandHash, existingDeal, instant, context);
                    context.gameState.sendHandResult(player, logic_types_1.RoundResult.CroupierWin, instant);
                    context.gameState.moveToNextRound(instant);
                    return true;
                }
            }
            return false;
        });
    }
    revealCroupierCard(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const autoCroupierRevealCommand = new auto_croupier_reveal_command_1.AutoCroupierRevealCommand();
            yield autoCroupierRevealCommand.executeCommand(commandHash, existingDeal, instant, context);
        });
    }
}
exports.CroupierBlackjackRule = CroupierBlackjackRule;
